<section class="top-section">
  <div class="container">

    <h1>{{'FOOTER.PRIVACY' | translate}}</h1>

    <ng-container *ngIf="currentLang === 'no'">
      <p class="last-update">Sist oppdatert: November 2025</p>

      <div class="content" data-header-contrast="light">
        <h2>1. Innledning</h2>
        <p>Denne personvernerklæringen beskriver hvordan Gi Pant AS (Org.nr. 934 988 809) behandler personopplysninger i appene <strong>Gi Pant</strong> og <strong>Henter Pant</strong>.</p>
        <p>Gi Pant AS opptrer som behandlingsansvarlig for all behandling av personopplysninger i tjenestene.</p>
        <p>Vi følger GDPR, norsk personopplysningslov og Datatilsynets retningslinjer.</p>

        <h2>2. Roller i tjenesten</h2>
        <p>Vi behandler opplysninger om følgende roller:</p>
        <ul>
          <li>Giver</li>
          <li>Spiller</li>
          <li>Foresatt</li>
          <li>Barn (&lt;15 år)</li>
          <li>Lagadministrator / trener</li>
        </ul>

        <h2>3. Hvilke data vi behandler</h2>
        <h3>3.1 Grunnleggende informasjon</h3>
        <ul>
          <li>navn</li>
          <li>adresse</li>
          <li>telefonnummer / e-post</li>
          <li>tilknytning til lag</li>
          <li>kontoinformasjon</li>
          <li>ordrehistorikk</li>
        </ul>
        <h3>3.2 Pant- og kvitteringsdata</h3>
        <ul>
          <li>pantbeløp</li>
          <li>kvitteringsbilder</li>
          <li>tidspunkt og transaksjonsdata</li>
        </ul>
        <h3>3.3 GPS-data (kun foresatt)</h3>
        <ul>
          <li>GPS brukes kun av foresatte</li>
          <li>levert av telefonens operativsystem (iOS/Android)</li>
          <li>oppdateringsfrekvens styres av OS (ikke av appen)</li>
          <li>brukes kun for geografisk matching av henteoppdrag</li>
          <li>lagres aldri permanent</li>
          <li>slettes automatisk etter maks 7 dager</li>
        </ul>
        <h3>3.4 Teknisk data</h3>
        <ul>
          <li>enhetsmodell</li>
          <li>OS-versjon</li>
          <li>feilrapporter (Crashlytics)</li>
        </ul>
        <p>Crashlytics mottar ikke identitetsdata, GPS-data eller barnedata.</p>
        <h3>3.5 Fødselsdato</h3>
        <p>Vi samler inn brukerens fødselsdato for å avgjøre om brukeren er mindreårig.</p>
        <p>Dette gjør at vi kan aktivere relevante sikkerhetsfunksjoner, foresattstyrte flyter og begrensede tilganger for mindreårige brukere.</p>
        <p>Vi bruker ikke fødselsdatoen til markedsføring eller profilering.</p>

        <h2>4. Hvordan vi samler inn data</h2>
        <h3>4.1 Direkte fra brukeren</h3>
        <ul>
          <li>registrering</li>
          <li>oppdatering av profil</li>
          <li>kvitteringsopplasting</li>
          <li>bestilling eller utføring av ordre</li>
        </ul>
        <h3>4.2 Via enheten</h3>
        <ul>
          <li>Kun foresatte kan gi lokasjonssamtykke.</li>
          <li>GPS leveres av OS når foresatte har aktivert dette.</li>
        </ul>
        <h3>4.3 Via integrerte systemer</h3>
        <ul>
          <li>Google Maps API (geokoding fra adresse)</li>
          <li>Crashlytics (tekniske feil)</li>
          <li>PowerOffice (fakturering)</li>
          <li>Nets (første betaling)</li>
        </ul>

        <h2>5. Rettslig grunnlag</h2>
        <p>Vi behandler data basert på:</p>
        <p>• Art. 6(1)(b) – Avtale</p>
        <p>Henteoppdrag, kvitteringer, fakturering.</p>
        <p>• Art. 6(1)(a) – Samtykke</p>
        <p>GPS for foresatte, opprettelse av barnkonto.</p>
        <p>• Art. 6(1)(f) – Berettiget interesse</p>
        <p>Adressebasert matching av spillere, sikkerhetskontroll.</p>
        <p>• Art. 8 – Barn</p>
        <p>Barn krever foresatt.</p>
        <p>• Bokføringsloven</p>
        <p>5 års lagring av kvitteringer.</p>

        <h2>6. Formål med behandlingen</h2>
        <p>Vi bruker data til:</p>
        <ul>
          <li>å tildele henteoppdrag</li>
          <li>å gi foresatte mulighet for GPS-baserte ordre</li>
          <li>å administrere lag og brukere</li>
          <li>å verifisere pant og kvitteringer</li>
          <li>betaling og fakturering</li>
          <li>å gi teknisk support</li>
          <li>å avdekke misbruk og svindel</li>
          <li>å forbedre tjenesten (ikke profilering)</li>
        </ul>

        <h2>7. GPS og lokasjon</h2>
        <h3>7.1 Hvem spores?</h3>
        <ul>
          <li>Foresatt: kan velge å aktivere GPS</li>
          <li>Spiller: spores aldri</li>
          <li>Barn: spores aldri</li>
          <li>Giver: spores aldri</li>
        </ul>
        <h3>7.2 Hvordan fungerer GPS?</h3>
        <ul>
          <li>OS styrer når posisjon leveres</li>
          <li>appen kan ikke definere nøyaktig intervall</li>
          <li>GPS brukes kun i sanntid</li>
          <li>lagres aldri i databasen</li>
          <li>slettes automatisk etter 7 dager</li>
        </ul>
        <h3>7.3 Pause-funksjon</h3>
        <p>Når pause er aktivert:</p>
        <ul>
          <li>ingen GPS-oppdateringer behandles</li>
          <li>ingen nye ordre tildeles</li>
          <li>ingen varsler sendes</li>
        </ul>

        <h2>8. Misbruk og sikkerhet</h2>
        <p>Vi kan suspendere eller stenge konto ved:</p>
        <ul>
          <li>farlig avfall</li>
          <li>misbruk av GPS</li>
          <li>svindel</li>
          <li>trusler / aggressiv oppførsel</li>
          <li>gjentatt feilrapportering</li>
        </ul>
        <p>Ved mistanke kan kontoen midlertidig suspenderes til saken er ferdig undersøkt.</p>

        <h2>9. Deling av data</h2>
        <p>Vi deler kun data med våre godkjente databehandlere:</p>
        <ul>
          <li>PowerOffice Go (NO) – fakturering</li>
          <li>Nets (NO/EU) – første betaling</li>
          <li>Hetzner Cloud (DE) – hosting</li>
          <li>Google Crashlytics (EU/USA) – tekniske feil, ingen identitet</li>
          <li>HubSpot (EU/USA) – kun B2B, ikke app-brukere</li>
        </ul>
        <p>Vi selger aldri personopplysninger.</p>

        <h2>10. Lagringstid</h2>
        <table border="1" cellpadding="6" cellspacing="0">
          <thead>
          <tr>
            <th>Type data</th>
            <th>Lagringstid</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>GPS (foresatt)</td>
            <td>maks 7 dager</td>
          </tr>
          <tr>
            <td>Kvitteringer</td>
            <td>5 år</td>
          </tr>
          <tr>
            <td>Kontodata</td>
            <td>slettes umiddelbart ved avslutning</td>
          </tr>
          <tr>
            <td>Teknisk data</td>
            <td>pseudonymiseres</td>
          </tr>
          </tbody>
        </table>

        <h2>11. Sletting</h2>
        <p>Du kan be om sletting ved å kontakte oss eller bruke appen.</p>
        <p>Sletting utføres umiddelbart, med unntak av data som må beholdes etter bokføringsloven.</p>

        <h2>12. Dine rettigheter</h2>
        <ul>
          <li>innsyn</li>
          <li>retting</li>
          <li>sletting</li>
          <li>begrensning</li>
          <li>dataportabilitet</li>
          <li>protest mot behandling</li>
        </ul>
        <p>Kontakt: personvern&#64;gipant.no</p>

        <h2>13. Overføring til tredjeland</h2>
        <p>Kun anonymiserte Crashlytics-logger kan sendes til USA.</p>
        <p>Ingen identifikatorer, GPS eller barnedata overføres.</p>
        <p>Tiltak:</p>
        <ul>
          <li>SCC 2021</li>
          <li>dataminimering</li>
          <li>pseudonymisering</li>
        </ul>
        <p>Residual risiko er vurdert som lav i TIA v1.2.</p>

        <h2>14. Sikkerhet</h2>
        <ul>
          <li>TLS 1.3</li>
          <li>AES-256</li>
          <li>tilgangsstyring (RBAC)</li>
          <li>pseudonymisering</li>
          <li>audit logs</li>
          <li>ingen sporing av barn</li>
        </ul>

        <h2>15. Kontaktinformasjon</h2>
        <ul>
          <li>Gi Pant AS</li>
          <li>E-post: personvern&#64;gipant.no</li>
          <li>Org.nr.: 934 988 809</li>
        </ul>

        <h3 class="mt-5"><a href="../../../assets/legal/Privacy-Policy_Personvernerklæring–GiPant-AS.pdf" download>Last ned fullstendig personvernerklæring (PDF)</a></h3>
      </div>
    </ng-container>


    <ng-container *ngIf="currentLang === 'en'">
      <p class="last-update">Last updated: November 2025</p>

      <div class="content" data-header-contrast="light">
        <h2>1. Introduction</h2>
        <p>This Privacy Policy explains how Gi Pant AS processes personal data in the <strong>Gi Pant</strong> and <strong>Henter Pant</strong> apps.</p>
        <p>Gi Pant AS is the Data Controller.</p>

        <h2>2. User Roles</h2>
        <p>We process data for the following roles:</p>
        <ul>
          <li>Donor</li>
          <li>Player</li>
          <li>Guardian</li>
          <li>Children (&lt; 15)</li>
          <li>Team administrator</li>
        </ul>

        <h2>3. Categories of Data Processed</h2>
        <h3>3.1 Basic Information</h3>
        <ul>
          <li>Name, address, contact details, team affiliation, account info, order history.</li>
        </ul>
        <h3>3.2 Deposit &amp; Receipt Data</h3>
        <ul>
          <li>Deposit amount, receipt photos, timestamps.</li>
        </ul>
        <h3>3.3 GPS Data (Guardians Only)</h3>
        <ul>
          <li>Only guardians may enable location</li>
          <li>OS-controlled intervals</li>
          <li>Used solely to match orders</li>
          <li>Never stored</li>
          <li>Deleted automatically after 7 days</li>
        </ul>
        <h3>3.4 Technical Data</h3>
        <ul>
          <li>Device, OS version, crash logs (Crashlytics).</li>
        </ul>
        <p>Crashlytics does not receive identity, GPS or child data.</p>
        <h3>3.5 Date of Birth</h3>
        <p>We collect the user’s date of birth to determine whether the user is a minor.</p>
        <p>This allows us to enable appropriate safety features, parental supervision flows, and restricted permissions for underage users.</p>
        <p>We do not use the date of birth for marketing or profiling purposes.</p>

        <h2>4. How Data Is Collected</h2>
        <ul>
          <li>user input</li>
          <li>guardian&apos;s OS location (if enabled)</li>
          <li>Google Maps API</li>
          <li>Crashlytics technical logs</li>
          <li>Nets / PowerOffice for payments</li>
        </ul>

        <h2>5. Legal Bases</h2>
        <ul>
          <li>Art. 6(1)(b) contract</li>
          <li>Art. 6(1)(a) consent (GPS, child accounts)</li>
          <li>Art. 6(1)(f) legitimate interests</li>
          <li>Art. 8 children</li>
          <li>Accounting Act (5 years receipts)</li>
        </ul>

        <h2>6. Purposes</h2>
        <ul>
          <li>matching pickup orders</li>
          <li>team management</li>
          <li>receipt verification</li>
          <li>billing</li>
          <li>support</li>
          <li>fraud prevention</li>
          <li>safety and misconduct handling</li>
        </ul>

        <h2>7. Location Data</h2>
        <p>Who is tracked?</p>
        <ul>
          <li>Only guardians.</li>
          <li>Players, donors, and children are never tracked.</li>
        </ul>
        <p>How GPS works</p>
        <ul>
          <li>delivered by phone OS</li>
          <li>real-time only</li>
          <li>never stored</li>
          <li>deleted after 7 days</li>
        </ul>
        <p>Pause</p>
        <ul>
          <li>Stops GPS, orders, and notifications.</li>
        </ul>

        <h2>8. Misconduct &amp; Security</h2>
        <p>Suspension or termination may occur in cases of:</p>
        <ul>
          <li>hazardous waste</li>
          <li>threats</li>
          <li>fraud</li>
          <li>repeated incorrect receipt entries</li>
          <li>misuse or manipulation</li>
        </ul>

        <h2>9. Data Sharing</h2>
        <p>Processors:</p>
        <ul>
          <li>PowerOffice Go</li>
          <li>Nets</li>
          <li>Hetzner Cloud</li>
          <li>Google Crashlytics (technical only)</li>
          <li>HubSpot (B2B only)</li>
        </ul>

        <h2>10. Retention</h2>
        <table border="1" cellpadding="6" cellspacing="0">
          <thead>
          <tr>
            <th>Data</th>
            <th>Duration</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>GPS</td>
            <td>7 days</td>
          </tr>
          <tr>
            <td>Receipts</td>
            <td>5 years</td>
          </tr>
          <tr>
            <td>Accounts</td>
            <td>deleted immediately</td>
          </tr>
          <tr>
            <td>Technical logs</td>
            <td>pseudonymized</td>
          </tr>
          </tbody>
        </table>

        <h2>11. User Rights</h2>
        <ul>
          <li>Access, correction, deletion, restriction, portability, objection.</li>
        </ul>
        <p>Contact: personvern&#64;gipant.no</p>

        <h2>12. Third-Country Transfers</h2>
        <ul>
          <li>Only anonymised Crashlytics logs are transferred.</li>
          <li>No identifiable data, GPS, or child data.</li>
          <li>Low residual risk per TIA v1.2.</li>
        </ul>

        <h2>13. Security</h2>
        <ul>
          <li>TLS 1.3, AES-256, RBAC, pseudonymisation, audit logs.</li>
        </ul>

        <h2>14. Contact</h2>
        <ul>
          <li>Gi Pant AS</li>
          <li>personvern&#64;gipant.no</li>
        </ul>

        <h3 class="mt-5"><a href="../../../assets/legal/Privacy-Policy_Personvernerklæring–GiPant-AS.pdf" download>Download the full Privacy Policy (PDF)</a></h3>
      </div>
    </ng-container>

  </div>
</section>
